import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

const passthroughErrors: (number | undefined)[] = [422];

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
    return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> | AxiosResponse | undefined => {
    if (passthroughErrors.includes(error?.status) || error?.response) {
        return error?.response;
    }

    return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    return axiosInstance;
}
